function parseBooleanFlag(value, defaultValue = false) {
  if (value == null || value === "") {
    return defaultValue;
  }

  const normalized = String(value).trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) {
    return true;
  }
  if (["0", "false", "no", "off"].includes(normalized)) {
    return false;
  }

  return defaultValue;
}

export const FEATURE_FLAGS = {
  enableWhatsAppImportInbox: parseBooleanFlag(
    process.env.REACT_APP_ENABLE_WHATSAPP_IMPORT_INBOX,
    false
  ),
};
